const styles = theme => ({
  root: {
    display: 'inline-block',
    opacity: 0
  }
});

export { styles };
